document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".impact-tab");
  const contents = document.querySelectorAll(".impact-tab-content");

  if (!tabs.length || !contents.length) return;

  tabs.forEach(tab => {
    tab.addEventListener("click", function () {
      const handle = this.dataset.handle;

      tabs.forEach(t => t.classList.remove("active"));
      this.classList.add("active");

      contents.forEach(c => {
        const isMatch = c.dataset.block === handle;
        c.classList.toggle("hidden", !isMatch);
      });
    });
  });
});